export enum WorkDirection {
  'INCREASING' = <any> 'I',
  'DECREASING' = <any> 'D'
}
